import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '../../../app/store';

export type WifiConfigState = {
  isEditing: boolean;
};

const initialState: WifiConfigState = {
  isEditing: false,
};

export const wifiConfigSlice = createSlice({
  name: 'wifiConfig',
  initialState,
  reducers: {
    resetWifiConfig: () => {
      return { ...initialState };
    },
    setIsEditing: (state, action: PayloadAction<boolean>) => {
      return { ...state, isEditing: action.payload };
    },
  },
});

export const { resetWifiConfig, setIsEditing } = wifiConfigSlice.actions;

export const selectWifiConfigState = (state: RootState) => {
  return state.wifiConfig;
};

export const { reducer: wifiConfigReducer } = wifiConfigSlice;
